// Axios verpackt die Antwort des Servers: seine eigene message nennt nur den
// Statuscode ("Request failed with status code 409"). Die Begruendung, die dem
// Nutzer weiterhilft, steht im Fehlerkontrakt des Servers (server/src/lib/errors.js:
// { error: { code, message } }) — sie hat darum Vorrang.
const getErrorMessage = error => (
    error?.response?.data?.error?.message
    ?? (error.hasOwnProperty('message') ? error.message : 'unknown')
)

export default getErrorMessage
